import React, { useEffect, useMemo, useRef } from "react";
import Highcharts from "highcharts";
import styles from "./MapPage.module.scss";
import { useGeoState } from "../../components/GeoProvider";
import { tooltip } from "leaflet";

const BottomBarGraph = ({ seriesMale, seriesFemale,categories }) => {
  const { getGenderFilter } = useGeoState(); // this is already the value
  const gender = getGenderFilter;            // alias for clarity

  const maleContainerRef = useRef(null);     // DOM nodes
  const femaleContainerRef = useRef(null);
  const maleChartRef = useRef(null);         // Highcharts instances
  const femaleChartRef = useRef(null);

  const maleOptions = useMemo(
    () => ({
      chart: { type: "bar" },
          credits: {
      enabled: false,
    },
    credits: {
        enabled: false,
      },
          tooltip: {
      // outside:true,
      enabled: true, //Added to disable tooltip
      borderRadius: 10,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0,
      },
      
      formatter: function () {
        return (
          `<div style="background-color: #FFFFFF;color:4B4D4F;padding: 12px 12px;border: 1px  solid #CBCCCD;
          border-radius: 4px; font-family: 'Optum Sans', sans-serif;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          ">
          <div >${this.series.name}</div>
          <div style='padding-top:10px'>${this.x}</div>
          
          <div style='padding-top:10px'>${this.y}
          </div>`
        )
      },
    },
      

      plotOptions: { series: { stacking: "normal" } },
      title: { text: "Male" },
      xAxis: {
        categories: categories,
       title: { text: 'Age Group', style: {
                fontSize: '12px'
            }},
        tickLength: 0,
      },
       yAxis: {
        title: { text: '#Members', style: {
                fontSize: '12px'
            }},
      },
      series:seriesMale, 
    }),
    [categories, seriesMale]
  );

  const femaleOptions = useMemo(
    () => ({
      chart: { type: "bar" },
      credits: {
        enabled: false,
      },
      plotOptions: { series: { stacking: "normal" } },
      title: { text: "Female" },
      xAxis: {
        categories: categories,
        title: { text: 'Age Group', style: {
                fontSize: '12px'
            }},
        tickLength: 0,
      },
        yAxis: {
        title: { text: '#Members' , style: {
                fontSize: '12px'
            }},
      },
      tooltip: {
      // outside:true,
      enabled: true, //Added to disable tooltip
      borderRadius: 10,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0,
      },
      
      formatter: function () {
        return (
          `<div style="background-color: #FFFFFF;color:4B4D4F;padding: 12px 12px;border: 1px  solid #CBCCCD;
          border-radius: 4px; font-family: 'Optum Sans', sans-serif;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          ">
          <div >${this.series.name}</div>
          <div style='padding-top:10px'>${this.x}</div>
          
          <div style='padding-top:10px'>${this.y}
          </div>`
        )
      },
    },
      series: seriesFemale, 
    }),
    [categories, seriesFemale]
  );

  useEffect(() => {
    const showMale = gender === "Male" || gender === "All";
    const showFemale = gender === "Female" || gender === "All";

    // --- MALE ---
    if (showMale && maleContainerRef.current) {
      if (!maleChartRef.current) {
        maleChartRef.current = Highcharts.chart(maleContainerRef.current, maleOptions);
      } else {
        maleChartRef.current.update(maleOptions, true, true);
      }
    } else if (maleChartRef.current) {
      maleChartRef.current.destroy();
      maleChartRef.current = null;
    }

    // --- FEMALE ---
    if (showFemale && femaleContainerRef.current) {
      if (!femaleChartRef.current) {
        femaleChartRef.current = Highcharts.chart(femaleContainerRef.current, femaleOptions);
      } else {
        femaleChartRef.current.update(femaleOptions, true, true);
      }
    } else if (femaleChartRef.current) {
      femaleChartRef.current.destroy();
      femaleChartRef.current = null;
    }

    // Cleanup on unmount
    return () => {
      if (maleChartRef.current) {
        maleChartRef.current.destroy();
        maleChartRef.current = null;
      }
      if (femaleChartRef.current) {
        femaleChartRef.current.destroy();
        femaleChartRef.current = null;
      }
    };
  }, [gender, maleOptions, femaleOptions]);

  return (
    <div
      style={{
        marginTop:"30px",
        width: "100%",
        border: "1.5px solid #cbcccd",
        borderRadius: "4px",
        //padding: "32px 24px",
      }}
    >
      <div style={{padding:"10px"}}>
        <span className={styles.captionFormat}>Age Group and Gender</span>
      </div>
      {categories.length === 0 ? (
        <div style={{ display: 'flex' ,padding:'10px',color:'#424242'}} >No data available for the selected filters</div>
      ) : (
      <div style={{ display: "flex", marginTop: "30px" }}>
        {(gender === "All" || gender === "Male") && seriesMale.length > 0 && (
          <div ref={maleContainerRef} style={{ width: "50%", height: "400px" }} />
        )}
        {(gender === "All" || gender === "Female") && seriesFemale.length > 0 && (
          <div ref={femaleContainerRef} style={{ width: "50%", height: "400px" }} />
        )}
      </div>)}
    </div>
  );
};

export default BottomBarGraph;